/* TI·FORGE Theme JS — AJAX 购物车抽屉 */
const CartDrawer = {
  open() {
    document.body.classList.add('cart-open');
    this.render();
  },
  close() {
    document.body.classList.remove('cart-open');
  },
  money(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, themeMoneyFormat || '${{amount}}')
      : '$' + (cents / 100).toFixed(2);
  },
  async add(variantId, qty = 1) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    });
    this.open();
  },
  async change(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    this.render();
    this.refreshCount();
  },
  async refreshCount() {
    const cart = await (await fetch('/cart.js')).json();
    document.getElementById('cartCount').textContent = cart.item_count;
  },
  async render() {
    const cart = await (await fetch('/cart.js')).json();
    const body = document.getElementById('cartBody');
    const foot = document.getElementById('cartFoot');
    document.getElementById('cartCount').textContent = cart.item_count;

    if (cart.item_count === 0) {
      body.innerHTML = `<div class="cart-empty"><p>YOUR CART IS EMPTY</p>
        <a href="/collections/all" onclick="CartDrawer.close()" style="text-decoration:underline;text-underline-offset:4px">CONTINUE SHOPPING</a></div>`;
      foot.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(i => `
      <div class="cart-item">
        ${i.image ? `<img src="${i.image}&width=160" alt="${i.title}">` : ''}
        <div class="info">
          <h4>${i.product_title}</h4>
          ${i.variant_title && i.variant_title !== 'Default Title' ? `<p class="variant">${i.variant_title}</p>` : ''}
          <div class="qty">
            <button onclick="CartDrawer.change('${i.key}', ${i.quantity - 1})">−</button>
            <span>${i.quantity}</span>
            <button onclick="CartDrawer.change('${i.key}', ${i.quantity + 1})">+</button>
          </div>
          <button class="remove" onclick="CartDrawer.change('${i.key}', 0)">REMOVE</button>
        </div>
        <p class="line-price">${this.money(i.final_line_price)}</p>
      </div>`).join('');
    document.getElementById('cartTotal').textContent = this.money(cart.total_price);
    foot.style.display = 'block';
  }
};

/* 首页产品网格：按产品类型筛选 */
function filterProducts(btn, type) {
  document.querySelectorAll('.filter-btns button').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.product-grid .card').forEach(c => {
    c.style.display = (type === 'All' || c.dataset.type === type) ? '' : 'none';
  });
}

/* 产品页：缩略图切换 */
function swapImage(el, src) {
  const main = document.querySelector('.pdp .gallery-main');
  main.innerHTML = `<img src="${src}" alt="">`;
  document.querySelectorAll('.pdp .thumbs img, .pdp .thumbs .thumb-video').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
}

/* 产品页：切换到视频 */
function swapMedia(el, mediaId) {
  const tpl = document.getElementById('media-' + mediaId);
  if (!tpl) return;
  document.querySelector('.pdp .gallery-main').innerHTML = tpl.innerHTML;
  document.querySelectorAll('.pdp .thumbs img, .pdp .thumbs .thumb-video').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
}

/* 产品页：加购 */
async function pdpAdd(form) {
  const fd = new FormData(form);
  await CartDrawer.add(fd.get('id'), parseInt(fd.get('quantity') || '1'));
  return false;
}

/* 产品页：描述区移除图片（图已在顶部相册展示），视频保留 */
document.addEventListener('DOMContentLoaded', () => {
  const rte = document.querySelector('.pdp-details .rte');
  if (!rte) return;
  rte.querySelectorAll('img, figure, picture').forEach(el => el.remove());
  // 清掉只包过图片的空段落
  rte.querySelectorAll('p, div').forEach(el => {
    if (!el.textContent.trim() && !el.querySelector('*')) el.remove();
  });
});

